import containerFuild from '../html-snippets/container-fuild';
import css from '../css-snippets/section-card-basic-rivoneed';
const html = `
<div class="container">
  <div class="wrap-card">
    <div
      data-attribute="left-card"
      data-color-border="#ffffff"
      class="left-card"
      data-order="1"
      style="--order-left: 1; --color-border: #ffffff"
    >
      <div data-attribute="title-content" class="title-content">
        <h2 style="text-align: center;">SPEC</h2>
        <p style="text-align: center;">Detailed specs for a confident purchase.</p>
      </div>
      <div data-attribute="list-item" class="list-item">
        <div data-attribute="item" class="item">
          <div data-attribute="label-item" class="label-item">Color</div>
          <div data-attribute="value-item" class="value-item">Red / Yellow / Green</div>
        </div>
        <div data-attribute="item" class="item">
          <div data-attribute="label-item" class="label-item">Max Brightness</div>
          <div data-attribute="value-item" class="value-item">3000 Lumens</div>
        </div>
        <div data-attribute="item" class="item">
          <div data-attribute="label-item" class="label-item">Light Modes</div>
          <div data-attribute="value-item" class="value-item">White / Yellow / Red</div>
        </div>
        <div data-attribute="item" class="item">
          <div data-attribute="label-item" class="label-item">Power</div>
          <div data-attribute="value-item" class="value-item">20W</div>
        </div>
        <div data-attribute="item" class="item">
          <div data-attribute="label-item" class="label-item">Battery</div>
          <div data-attribute="value-item" class="value-item">5200mAh</div>
        </div>
        <div data-attribute="item" class="item">
          <div data-attribute="label-item" class="label-item">Runtime</div>
          <div data-attribute="value-item" class="value-item">6-24h</div>
        </div>
        <div data-attribute="item" class="item">
          <div data-attribute="label-item" class="label-item">Charging</div>
          <div data-attribute="value-item" class="value-item">Type-C</div>
        </div>
        <div data-attribute="item" class="item">
          <div data-attribute="label-item" class="label-item">Protection</div>
          <div data-attribute="value-item" class="value-item">IK08 Impact / IPX4 Water</div>
        </div>
        <div data-attribute="item" class="item">
          <div data-attribute="label-item" class="label-item">Material</div>
          <div data-attribute="value-item" class="value-item">ABS</div>
        </div>
      </div>
    </div>
    <div data-attribute="right-card" class="right-card" data-order="2" style="--order-right: 2">
      <div class="wrap-img">
        <img
          data-attribute="image-card"
          src="https://cdn.skyfastimg.com/images/2026/06/15/image-6a2f9e1bd221b66281629507.webp"
          alt=""
        />
      </div>
    </div>
  </div>
</div>
`;
export default containerFuild(html, css, {
  backgroundColor: '#1a1a1a',
  textColor: '#ffffff',
});
